var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09664 6.6133C7.91358 6.79636 7.64683 6.86795 7.39671 6.80116C6.18485 6.47753 4.84135 6.79169 3.89292 7.74011C2.47682 9.15622 2.47681 11.4522 3.89292 12.8683C5.30903 14.2844 7.60499 14.2844 9.02109 12.8683C9.96952 11.9199 10.2837 10.5764 9.96005 9.3645C9.89326 9.11438 9.96485 8.84763 10.1479 8.66457L12.269 6.5435C12.4578 6.35468 12.7639 6.35468 12.9528 6.5435C13.0472 6.63791 13.2003 6.63791 13.2947 6.5435L13.7647 6.07343C14.1188 5.7194 14.1188 5.14541 13.7647 4.79138L13.1237 4.15035C12.4156 3.44229 11.2677 3.44229 10.5596 4.15035L8.09664 6.6133ZM7.58383 6.10048C6.13213 5.7128 4.51899 6.08841 3.3801 7.2273C1.68078 8.92662 1.68078 11.6818 3.3801 13.3811C5.07943 15.0804 7.83458 15.0804 9.53391 13.3811C10.6728 12.2422 11.0484 10.6291 10.6607 9.17738L12.6109 7.22724C12.8941 7.51047 13.3533 7.51047 13.6366 7.22723C13.8502 7.01356 14.0639 6.7999 14.2776 6.58623C14.9148 5.94899 14.9148 4.91582 14.2775 4.27859L13.3361 3.33717C12.5107 2.5118 11.1725 2.51181 10.3471 3.33719L7.58383 6.10048Z",
    fill: "#2D3436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94373 9.79126C5.6605 10.0745 5.6605 10.5337 5.94373 10.8169C6.22695 11.1001 6.68614 11.1001 6.96936 10.8169C7.25258 10.5337 7.25258 10.0745 6.96936 9.79126C6.68614 9.50804 6.22695 9.50804 5.94373 9.79126ZM5.43091 11.3297C4.86447 10.7633 4.86447 9.84488 5.43091 9.27844C5.99735 8.712 6.91574 8.712 7.48218 9.27844C8.04862 9.84488 8.04862 10.7633 7.48218 11.3297C6.91574 11.8962 5.99735 11.8962 5.43091 11.3297Z",
    fill: "#2D3436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey2);
export default __webpack_public_path__ + "static/media/key-2.613ee261e486061eddfe3f2d0cb46ad3.svg";
export { ForwardRef as ReactComponent };